import {
  publishers,
  brands,
  keywords,
  content,
  categories,
} from 'api';

import {
  FETCH_PUBLISHERS_LIST,
  FETCHED_PUBLISHERS_LIST,
  FETCH_BRANDS_LIST,
  FETCHED_BRANDS_LIST,
  FETCH_KEYWORDS_LIST,
  FETCHED_KEYWORDS_LIST,
  FETCH_CATEGORIES_LIST,
  FETCHED_CATEGORIES_LIST,
} from 'components/Global/Filters/actions.js';

import { fetchPayload, fetchList } from '@bit/knotchinc.web-react-components.utils.fetch-actions';

export const FETCH_PUBLISHER_METADATA = 'FETCH_PUBLISHER_METADATA';
export const FETCHED_PUBLISHER_METADATA = 'FETCHED_PUBLISHER_METADATA';

export const FETCH_PUBLISHER_TOP_KEYWORDS = 'FETCH_PUBLISHER_TOP_KEYWORDS';
export const FETCHED_PUBLISHER_TOP_KEYWORDS = 'FETCHED_PUBLISHER_TOP_KEYWORDS';
export const SET_PUBLISHER_TOP_KEYWORDS_FILTER = 'SET_PUBLISHER_TOP_KEYWORDS_FILTER';

export const FETCH_PUBLISHER_CONTENT_OVER_TIME = 'FETCH_PUBLISHER_CONTENT_OVER_TIME';
export const FETCHED_PUBLISHER_CONTENT_OVER_TIME = 'FETCHED_PUBLISHER_CONTENT_OVER_TIME';
export const SET_PUBLISHER_CONTENT_OVER_TIME_FILTER = 'SET_PUBLISHER_CONTENT_OVER_TIME_FILTER';

export const FETCH_PUBLISHER_PAID_CONTENT = 'FETCH_PUBLISHER_PAID_CONTENT';
export const FETCHED_PUBLISHER_PAID_CONTENT = 'FETCHED_PUBLISHER_PAID_CONTENT';
export const SET_PUBLISHER_PAID_CONTENT_FILTER = 'SET_PUBLISHER_PAID_CONTENT_FILTER';

export const FETCH_PUBLISHER_TOP_BRANDS = 'FETCH_PUBLISHER_TOP_BRANDS';
export const FETCHED_PUBLISHER_TOP_BRANDS = 'FETCHED_PUBLISHER_TOP_BRANDS';
export const SET_PUBLISHER_TOP_BRANDS_FILTER = 'SET_PUBLISHER_TOP_BRANDS_FILTER';

export const fetchPublisherMetadata = id => dispatch =>
  fetchPayload({
    dispatch,
    fetchingActionType: FETCH_PUBLISHER_METADATA,
    fetchedActionType: FETCHED_PUBLISHER_METADATA,
    apiCall: () => publishers.getPublisherMetadata(id),
  });

export const fetchPublisherPaidContent = (clear, publisherId) => (dispatch, getState) => fetchList({
  clear,
  dispatch,
  getState,
  store: getState().PublisherProfile.paidContentList,
  fetchingActionType: FETCH_PUBLISHER_PAID_CONTENT,
  fetchedActionType: FETCHED_PUBLISHER_PAID_CONTENT,
  apiCall: (filters) => content.getPublisherContent(publisherId, filters),
});

export const fetchPublishersTopBrands = (clear, id) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().PublisherProfile.topBrandList,
    fetchingActionType: FETCH_PUBLISHER_TOP_BRANDS,
    fetchedActionType: FETCHED_PUBLISHER_TOP_BRANDS,
    apiCall: filters => brands.getPublishersBrands(id, filters),
  });

export const fetchPublishersTopKeywords = (clear, id) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().PublisherProfile.topKeywordList,
    fetchingActionType: FETCH_PUBLISHER_TOP_KEYWORDS,
    fetchedActionType: FETCHED_PUBLISHER_TOP_KEYWORDS,
    apiCall: filters => keywords.getPublishersKeywords(id, filters),
  });

export const fetchPublisherContentOverTime = (clear, publisherId) => (dispatch, getState) =>
  fetchPayload({
    clear,
    dispatch,
    getState,
    store: getState().PublisherProfile.contentOverTimeList,
    fetchingActionType: FETCH_PUBLISHER_CONTENT_OVER_TIME,
    fetchedActionType: FETCHED_PUBLISHER_CONTENT_OVER_TIME,
    apiCall: (filters) => content.getPublisherContentOverTime(publisherId, filters),
  });

export const fetchComparedPublishers = (clear) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().PublishersList.publishersList,
    fetchingActionType: FETCH_PUBLISHERS_LIST,
    fetchedActionType: FETCHED_PUBLISHERS_LIST,
    apiCall: (filters) => publishers.getPublishersList(filters),
  });

export const fetchPublisherKeywords = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().KeywordsList.keywordsList,
    fetchingActionType: FETCH_KEYWORDS_LIST,
    fetchedActionType: FETCHED_KEYWORDS_LIST,
    apiCall: (filters) => keywords.getPublishersKeywords(entityId, filters),
  });

export const fetchPublisherCategories = (clear, entityId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().CategoriesList.categoriesList,
    fetchingActionType: FETCH_CATEGORIES_LIST,
    fetchedActionType: FETCHED_CATEGORIES_LIST,
    apiCall: (filters) => categories.getPublisherCategories(entityId, filters),
  });

export const fetchPublisherBrands = (clear, publisherId) => (dispatch, getState) =>
  fetchList({
    clear,
    dispatch,
    getState,
    store: getState().BrandsList.brandsList,
    fetchingActionType: FETCH_BRANDS_LIST,
    fetchedActionType: FETCHED_BRANDS_LIST,
    apiCall: (filters) => brands.getPublishersBrands(publisherId, filters),
  });
